import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { Redirect, useLocation, useParams } from 'react-router-dom';
import { setPendingDeepLink } from './deepLinkStore';

/**
 * Captura la URL de un deep link, deja la acción pendiente y redirige
 * a la página destino. El registro es síncrono para no perder el payload
 * al desmontar esta ruta.
 */
const DeepLinkGate = ({ definition }) => {
  const params = useParams();
  const location = useLocation();
  const didRegister = useRef(false);

  if (!didRegister.current) {
    didRegister.current = true;
    if (definition.action) {
      const payload = definition.getPayload
        ? definition.getPayload(params, location)
        : { ...params };

      setPendingDeepLink({
        action: definition.action,
        payload,
      });
    }
  }

  return <Redirect to={definition.targetPath} />;
};

DeepLinkGate.propTypes = {
  definition: PropTypes.shape({
    path: PropTypes.string.isRequired,
    targetPath: PropTypes.string.isRequired,
    action: PropTypes.string,
    getPayload: PropTypes.func,
  }).isRequired,
};

export default DeepLinkGate;
